import React from "react";
import "./style.css";
import { Col, Row } from "antd";
import { dentalIcons } from "../../../../utils-icons/dentalIcons";
import DoughnutProgress from "../../../../components/chart/DoughnutProgress";

const TotalCases = ({
  type,
  totalCases,
  pending,
  added,
  count,
  isOpenSearch,
}) => {
  return (
    <div className="d-total_cases_container">
      <div className="total_case_body">
        <Row gutter={10} justify={"space-between"}>
          <Col md={8}>
            <div className="total_case_left">
              <div className="total_case_left_info">
                <p className="case_info_key">{type} Cases</p>
              </div>
              <div className="total_case_left_info_data">
                <div className="case_icon">
                  <span>Added</span>
                </div>
                <p>{added ?? 0}</p>
              </div>
              <div className="total_case_left_info_data">
                <div className="case_icon">
                  <span>Pending</span>
                </div>

                <p>{isOpenSearch ? "-" : (totalCases ?? 0) - (added ?? 0)}</p>
              </div>
            </div>
          </Col>

          <Col md={10}>
            <div className="total_case_progress">
              <div
                style={{
                  width: 2,
                  height: 88,
                  background: "#E8E8ED",
                  marginRight: 20,
                }}
              ></div>

              <DoughnutProgress
                male={count?.male}
                female={count?.female}
                unknown={count?.unknown}
                count={
                  isOpenSearch
                    ? (count?.male || 0) +
                      (count?.female || 0) +
                      (count?.unknown || 0)
                    : totalCases
                }
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="total_case_bottom">
              <div className="total_case_bottom_info">
                <p className="bottom_key">Male</p>
                <p className="bottom_value" style={{ color: "#20C3FF" }}>
                  {count?.male}
                </p>
              </div>
              <div className="total_case_bottom_info">
                <p className="bottom_key">Female</p>
                <p className="bottom_value" style={{ color: "#50F5AE" }}>
                  {count?.female}
                </p>
              </div>
              <div className="total_case_bottom_info">
                <p className="bottom_key">Unknown</p>
                <p className="bottom_value" style={{ color: "#C5C5C5" }}>
                  {count?.unknown}
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default TotalCases;
